module.exports = __webpack_public_path__ + "assets/img/HJ.03852231.png";